import type { CancelReasonOption } from './types';

/** The text of a cancel reason lives in the page's translations under this key. */
export const cancelReasonKey = (code: string): string => `cancelReason.option.${code}`;

/**
 * Cancel handlers are also bound straight to `onClick` (the default template's pages), so the
 * argument may be a click event rather than a picked item.
 */
export const isCancelReasonOption = (value: unknown): value is CancelReasonOption =>
  typeof value === 'object' &&
  value !== null &&
  typeof (value as CancelReasonOption).id === 'number' &&
  typeof (value as CancelReasonOption).code === 'string';

/**
 * Items whose code has no translation are not offered: a raw key on screen is worse than one
 * option fewer. The order is the dictionary's.
 */
export const visibleCancelReasons = (
  items: CancelReasonOption[],
  exists: (key: string) => boolean,
): CancelReasonOption[] => items.filter((item) => exists(cancelReasonKey(item.code)));
